import { Row as AntdRow } from 'antd';
import styled from 'styled-components';
export const CardsRow = styled(AntdRow) `
  margin-bottom: 32px;
`;
export const Row = AntdRow;
